$(document).ready(function () {
  $('.tab-links a').on('click', function (e) {
    e.preventDefault();
    
    const targetTab = $(this).attr('href');
    
    // Remove active class from all tabs and links
    $('.tab-links a').removeClass('active');
    $('.tab-content').removeClass('active');

    // Add active class to clicked tab and corresponding content
    $(this).addClass('active');
    $(targetTab).addClass('active');
  });
});
